module.exports = __webpack_public_path__ + "content/0ca3372616dee872d868120f784acfa8.png";